
    import Pencil from 'vue-material-design-icons/GreasePencil.vue';
    import Delete from 'vue-material-design-icons/Delete.vue';
    import myMixins from '@/mixins/myMixins';
    import "vue-select/dist/vue-select.css";
    import {http} from "@/config/httpCommon";
    import Key from 'vue-material-design-icons/Key.vue';
    import {
      getLastPage,
      getPageModal,
      handleResponseException,
      handleUserLoginLogOutAction,
      removePageModal, setPageModal
    } from "@/helpers/Helpers";
    import {captureImpersonationStash, saveImpersonationStash} from "@/helpers/impersonation";
    import SearchItems from "@/components/SearchItems.vue";
    export default {
      mixins: [myMixins],
      components:{
            Delete,
            Pencil,
            SearchItems,
            Key
        },
        data () {
            return {
              search: '',
              pagination:{
                rows:null,
                currentPage:null,
                perPage:null,
                total:0
              },
                isUpdating:false,
                roleModal: false,
                name: '',
                id:'',
                formStatus: 'create user',
                roles: [],
                messages:[],
                headers: [
                    {key: 'name', sortable: true,},
                    {key: 'email', sortable: true},
                    {key: 'company_name', sortable: true, label: 'Company Name'},
                    {key: 'company_url', sortable: true, label: 'Company Url' },
                    {key: 'phone', sortable: true, label: 'Phone'},
                    {key: 'address', sortable: true, label: 'Address'},
                    {key: 'city', sortable: true, label: 'City'},
                    {key: 'country', sortable: true, label: 'Country'},
                    {key: 'role_name', sortable: true, label: 'User Group'},
                    {key: 'actions', label: 'Actions'}
                ],
                users: [],
                form:{
                    id:'',
                    name:'',
                    email:'',
                    password:'',
                    role:'',
                    company_id:1,
                    password_confirmation:'',
                    entity_ids:[],
                    commission: null,
                },
                entityOptions: [],
                factoryOptions: [],
                customerOptions: [],
                companiesOptions: [],
                companiesLoading: false,
                selected_entities:[],
                saved_role:null,
                saved_entities:[],
                entity_name :'',
                default_user_for_factory_id:[],
                userRole : null,
                userToDelete: null,
                // AB#19866 (Phase 2): merchant customer-role grant tree
                grantCatalog: [],
                grantCatalogLoading: false,
                grantState: {}, // { [roleId]: { permission_ids: number[], is_default: bool } }
                companyDefault: null, // effective company default {role_id, label, is_merchant_owned}
            }
        },
      computed: {
          prefixedEntityName() {
            return 'select ' + this.entity_name;
          },
          isAdminRole() {
            return item => ['merchantgroupadmin','admin', 'adminsalesrep', 'manager'].includes(item.role_name.toLowerCase()) && item.company;
            },
            isSalesRepRole() {
              return this.form.role && this.form.role.name && this.form.role.name.toLowerCase() === 'salesrepresentative';
          },
            // AB#19866 (Phase 2): the merchant (Company Admin) role gets the grant tree.
            isMerchantRole() {
              return this.form.role && this.form.role.name && this.form.role.name.toLowerCase() === 'admin';
            },
            selectedRoleCount() {
              return Object.keys(this.grantState).length;
            }
        },
        async mounted() {

          this.userRole = await this.$store.getters.userRole;

          if(this.userRole.name == 'SuperAdmin' || this.userRole.name == 'CSManager') {
            this.getFactories();
            this.getCompanies();
          } else if(this.userRole.name == 'admin') {
            this.getCustomers();
          }
          //this.getUsers("");
          this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getUsers)
          const get_roles = await http.get(`role?type=admin&limit_role_options=1`)
          this.roles = get_roles.data.result.roles;

        },
        methods: {
          showmodal(){
            this.$bvModal.show("orderchat");
          },
          async getUsers(params){
            let res = await this.$store.dispatch("getusers", params);
            this.users = this.$store.getters.getusers;
            this.makePagination(res.data);
          },
          async getFactories() {
            let res = await this.$store.dispatch("getAllFactories");

            const optionArray = [];
             res.data.map(function (obj) {
              optionArray.push({id: obj.id, label: obj.name});
            })
            this.factoryOptions = optionArray

          },
          async getCustomers() {
            let res = await this.$store.dispatch("getCompanyCustomers");
            const optionArray = [];
            res.data.result.map(function (obj) {
              optionArray.push({id: obj.id, label: obj.full_name});
            })
            this.customerOptions = optionArray

          },
          async getCompanies(role = '', userId = '') {
            this.companiesLoading = true;
            const queryParts = [];
            if (role) {
              queryParts.push(`role=${role}`);
            }
            if (userId) {
              queryParts.push(`user_id=${userId}`);
            }
            const params = queryParts.length ? `?${queryParts.join('&')}` : '';
            try {
              let res = await this.$store.dispatch("getCompanies", params);
              const optionArray = [];
              res.data.result.map(function (obj) {
                optionArray.push({id: obj.id, label: obj.company_name});
              })
              this.companiesOptions = optionArray
            } finally {
              this.companiesLoading = false;
            }

          },
          makePagination(data){
            this.pagination.currentPage = data.current_page;
            this.pagination.rows = data.total;
            this.pagination.perPage = data.per_page;
            this.pagination.total = data.total;
          },
          searchUser(){
            let params = ''
            if(this.search) {
              params = '?search='+this.search;
            }
            setPageModal(1,this.$route.name,this.search);
            this.getUsers(params);
          },
            showModal(action){
                if (action == 'create'){
                    this.clearForm();
                }
                this.$bvModal.show("usersModal");
            },
            async saveuser() {
                if (this.isSalesRepRole) {
                    this.sanitizeCommission();
                    if (this.form.commission === null || this.form.commission === '') {
                        this.showToast("Commission (%) is required for Sales Representative", "DANGER");
                        return;
                    }
                }
                let valid = await this.$validator.validate();
                if(valid){
                    try{
                        if (this.isSalesRepRole) {
                          this.sanitizeCommission();
                        } else {
                          this.form.commission = null;
                        }
                        this.form.role_name = this.form.role['name'];
                        // AB#19866 (Phase 2): capture id (create) / reuse form.id (update) for grant sync.
                        const isMerchant = this.isMerchantRole;
                        let savedUserId = this.form.id;
                        if (this.isUpdating == false){

                            const addRes = await this.$store.dispatch("adduser", this.form);
                            savedUserId = (addRes && addRes.data && addRes.data.user) ? addRes.data.user.id : null;
                            this.showToast("User created successfully", "SUCCESS");
                            this.nextPageOnCreation('page','search', this.users.length, this.pagination.perPage, this.pagination.currentPage, getLastPage(this.pagination.perPage ,this.pagination.total ), this.$route.name, this.getUsers);
                        }else if (this.isUpdating == true){

                            await this.$store.dispatch("updateuser", this.form);
                            this.formStatus = "Create User"
                            this.showToast("User updated successfully", "SUCCESS");
                            this.preservePagination( 'page', 'search', this.$route.name, this.getUsers)

                        }
                        // AB#19866 (Phase 2): persist the merchant's customer-role grants.
                        if (isMerchant && savedUserId) {
                            try {
                                await this.saveMerchantGrants(savedUserId);
                            } catch (e) {
                                const msg = (e.response && e.response.data && e.response.data.message) || 'Failed to save customer roles';
                                this.showToast(msg, 'DANGER');
                            }
                        }
                        this.clearForm();
                        this.isUpdating = false
                        this.$bvModal.hide("usersModal");
                        
                    }catch(err){
                        let errors = err.response.data.errors;
                        let errArr = [];
                        Object.keys(errors).map((field) => {
                            errArr.push(errors[field][0]);
                        });
                        for (let i = 0; i < errArr.length; i++) {
                            this.showToast(errArr[i], 'DANGER');
                        }
                    }
                }
            },
            showDeleteUserModal(item) {
              this.userToDelete = item.item;
              this.$bvModal.show('deleteUserModal');
            },
            async deleteuser(){
                try{
                    await this.$store.dispatch("deleteuser", this.userToDelete);
                    this.users = this.$store.getters.getusers;
                    this.previousPageOnDeletion('page','search',this.users.length,this.$route.name,this.getUsers);
                    this.showToast("User deleted successfully", "SUCCESS");
                    this.$bvModal.hide('deleteUserModal')
                }catch(err){
                    console.log("Errror", err)
                    this.$bvModal.hide('deleteUserModal')
                }
            },
             editUser(item){
               this.formStatus = "Update User"
               this.isUpdating = true;
               this.form.id = item.id;
               this.form.name = item.name;
               this.form.email = item.email;
               this.form.password = item.password;
               this.form.password_confirmation = item.password_confirmation;
             this.form.commission = item.commission || null;
               this.saved_role = null;
               if (Object.keys(item.roles).length != 0) {
                 this.form.role = {
                   id: item.roles[0].id,
                   name: item.roles[0].name
                 }
                 this.saved_role = item.roles[0].name;
               }

               this.saved_entities = [];
               if(item.entities.length > 0 ) {
                  item.entities.map(obj => {
                    this.saved_entities.push({id: obj.sourceable_id, label: obj.name});
                 })
               } else {
                 this.default_user_for_factory_id = []
                 if (item.factories && item.factories.length > 0) {
                   item.factories.map(obj => {
                     this.saved_entities.push({id: obj.id, label: obj.name});
                     if (obj.pivot.default_factory_user == 1){
                       this.default_user_for_factory_id.push({id:obj.id,name:obj.name});
                     }
                   })
                 }
               }

               this.changeRole(this.form.role);
               this.showModal('edit');
            },
          async changeRole(role) {
            this.entityOptions = [];
            this.form.entity_ids = [];
            this.selected_entities = [];
            if (role && role.name && role.name.toLowerCase() !== 'salesrepresentative') {
              this.form.commission = null;
            }
            if(role.name == 'Manager') {
              this.entityOptions = this.customerOptions;
              this.entity_name = 'Customers'
            } else if(role.name == 'LimitedSuperAdmin') {
              await this.getCompanies();
              this.entityOptions = this.companiesOptions;
              this.entity_name = 'Companies'
            }  else if(role.name == 'Factory' || role.name == 'OrderAdministrator' || role.name == 'LogisticAssistant') {
              this.entityOptions = this.factoryOptions;
              this.entity_name = 'Factories'
            } else if(role.name == 'CSManager' || role.name == 'salesRepresentative' || role.name == 'MerchantGroupAdmin') {
              await this.getCompanies(role.name, this.form.id);
              this.entityOptions = this.companiesOptions;
              this.entity_name = 'Companies'
            }

            if(this.saved_role == role.name) {
              this.selected_entities = this.saved_entities;
              this.selected_entities.map(obj => {
                this.form.entity_ids.push(obj.id);
              })
            }

            // AB#19866 (Phase 2): merchant → load role/permission catalog + existing grants.
            if (role && role.name && role.name.toLowerCase() === 'admin') {
              await this.loadGrantCatalog();
              if (this.isUpdating && this.form.id) {
                await this.loadExistingGrants(this.form.id);
              }
            } else {
              this.resetGrantState();
            }
          },
          changeEntity() {
            if(this.form.role.name == 'Factory') {
              if(this.selected_entities.length > 1) {
                this.selected_entities.pop();
                this.showToast('Only one factory can be selected against a user');
              }
            }

            this.form.entity_ids = [];
            this.selected_entities.map(obj => {
              this.form.entity_ids.push(obj.id);
            })

            if((this.userRole.name == 'Factory') && this.form.id != '' && this.default_user_for_factory_id.length > 0){
                for(let user_factory of this.default_user_for_factory_id){
                  if (!this.form.entity_ids.includes(user_factory.id)){
                    this.selected_entities.push({
                      id: user_factory.id,
                      label: user_factory.name
                    });
                    this.form.entity_ids.push(user_factory.id);
                    this.showToast(`This is default user for ${user_factory.name} factory. Please change default user first in factory module`, "Error");
                    break;
                  }
                }
            }

          },
            clearForm(){
                this.isUpdating = false;
                this.form.id = '';
                this.form.name ='';
                this.form.email ='';
                this.form.password ='';
                this.form.role ='';
                this.form.password_confirmation ='';
                this.form.entity_ids = [];
              this.form.commission = null;
                this.default_user_for_factory_id = [];
                this.selected_entities = [];
                this.saved_entities = [];
                this.saved_role = null;
                this.resetGrantState();
            },
            // ===== AB#19866 (Phase 2): merchant customer-role grant tree =====
            async loadGrantCatalog() {
                if (this.grantCatalog.length) return;
                this.grantCatalogLoading = true;
                try {
                    const res = await http.get('merchant-role-catalog');
                    this.grantCatalog = (res.data && res.data.data) ? res.data.data : [];
                } catch (e) {
                    this.showToast('Failed to load customer roles', 'DANGER');
                } finally {
                    this.grantCatalogLoading = false;
                }
            },
            async loadExistingGrants(userId) {
                this.resetGrantState();
                if (!userId) return;
                try {
                    const res = await http.get(`users/${userId}/customer-role-grants`);
                    const grants = (res.data && res.data.data) ? res.data.data : [];
                    grants.forEach(g => {
                        this.$set(this.grantState, g.role_id, {
                            permission_ids: Array.isArray(g.permission_ids) ? g.permission_ids.map(Number) : [],
                            is_default: !!g.is_default,
                        });
                    });
                    // Effective company default (may be a merchant-owned role not in the catalog).
                    this.companyDefault = (res.data && res.data.company_default) ? res.data.company_default : null;
                } catch (e) { /* merchant has no grants yet — leave tree empty */ }
            },
            resetGrantState() {
                Object.keys(this.grantState).forEach(k => this.$delete(this.grantState, k));
                this.companyDefault = null;
            },
            // A merchant has set one of their own roles as the company default (not in this catalog).
            merchantDefaultActive() {
                return !!(this.companyDefault && this.companyDefault.is_merchant_owned);
            },
            isRoleSelected(roleId) {
                return Object.prototype.hasOwnProperty.call(this.grantState, roleId);
            },
            isRoleIndeterminate(roleId) {
                const node = this.grantState[roleId];
                if (!node) return false;
                const role = this.grantCatalog.find(r => r.id === roleId);
                const total = role && role.permissions ? role.permissions.length : 0;
                const sel = node.permission_ids.length;
                return sel > 0 && sel < total;
            },
            toggleRole(role, checked) {
                if (checked) {
                    this.$set(this.grantState, role.id, {
                        permission_ids: (role.permissions || []).map(p => p.id),
                        is_default: false,
                    });
                } else {
                    this.$delete(this.grantState, role.id);
                }
                this.normalizeDefault();
            },
            isPermChecked(roleId, permId) {
                const node = this.grantState[roleId];
                return !!node && node.permission_ids.includes(permId);
            },
            togglePerm(roleId, permId, checked) {
                const node = this.grantState[roleId];
                if (!node) return;
                const idx = node.permission_ids.indexOf(permId);
                if (checked && idx === -1) node.permission_ids.push(permId);
                if (!checked && idx !== -1) node.permission_ids.splice(idx, 1);
            },
            setDefaultRole(roleId) {
                Object.keys(this.grantState).forEach(k => {
                    this.grantState[k].is_default = (Number(k) === Number(roleId));
                });
            },
            // Keep at most one default. If the merchant already owns the company default, don't force
            // one here — leaving all unmarked keeps the merchant's default (superadmin can still pick
            // one to override, which prompts a confirm on save).
            normalizeDefault() {
                const keys = Object.keys(this.grantState);
                if (this.merchantDefaultActive()) return;
                if (keys.length === 1) {
                    this.grantState[keys[0]].is_default = true;
                } else if (keys.length > 1 && !keys.some(k => this.grantState[k].is_default)) {
                    this.grantState[keys[0]].is_default = true;
                }
            },
            buildGrantedRolesPayload() {
                return Object.keys(this.grantState).map(roleId => ({
                    role_id: Number(roleId),
                    permission_ids: this.grantState[roleId].permission_ids.slice(),
                    is_default: !!this.grantState[roleId].is_default,
                }));
            },
            async saveMerchantGrants(userId) {
                if (!userId) return;
                const payload: any = { granted_roles: this.buildGrantedRolesPayload() };
                // If the superadmin picked a default while the merchant already owns the default,
                // confirm the override before it replaces the merchant's choice.
                const picked = payload.granted_roles.find(g => g.is_default);
                if (this.merchantDefaultActive() && picked && picked.role_id !== this.companyDefault.role_id) {
                    const ok = await this.$bvModal.msgBoxConfirm(
                        `The merchant has set '${this.companyDefault.label}' as the company default. Override it with the role you selected?`,
                        { title: 'Override merchant default?', okTitle: 'Yes, override', okVariant: 'warning', cancelTitle: 'Cancel' }
                    );
                    if (ok) {
                        payload.override_default = true;
                    } else {
                        // Keep the merchant's default: save roles/permissions but don't change the default.
                        payload.granted_roles.forEach(g => { g.is_default = false; });
                    }
                }
                await http.post(`users/${userId}/customer-role-grants`, payload);
            },
          async handlePagination(page=''){
            let params = '?page='+page;
            if(this.search) {
              params += '&search='+this.search
            }
            setPageModal(page,this.$route.name,this.search);
            this.getUsers(params);
          },
          loginUser(id){
            http.get(`login-admin-user/${id}`).then(async (successResponse) =>{
              let response_data = successResponse.data;
              if(response_data.success) {
                // Remember who the REAL admin is before the session is swapped,
                // so the app can show an impersonation banner and restore the
                // original session on "Exit impersonation".
                const impersonation_stash = captureImpersonationStash();
                await handleUserLoginLogOutAction('logout');
                // Save BEFORE the login call: setAuthUserData may immediately
                // redirect to the new dashboard (access-new-dashboard), which
                // unloads the page and would otherwise drop the stash.
                saveImpersonationStash(impersonation_stash);
                await handleUserLoginLogOutAction('login', response_data.result);
                location.reload()
              } else {
                this.showServerErrors(successResponse)
              }
              this.submitted = false;
            }).catch(error => {
              this.submitted = false;
              handleResponseException(error)
            });
          },
          sanitizeCommission() {
            if (this.form.commission === null || this.form.commission === '') {
              this.form.commission = null;
              return;
            }
            const numericVal = Number(this.form.commission);
            if (Number.isNaN(numericVal)) {
              this.form.commission = null;
              return;
            }
            const floored = Math.floor(numericVal);
            if (floored > 100) {
              this.showToast('Commission cannot exceed 100%', 'DANGER');
            }
            const bounded = Math.max(0, Math.min(100, floored));
            this.form.commission = bounded;
          },
          restrictCommissionInput(e) {
            const allowedKeys = ['Backspace','Delete','Tab','ArrowLeft','ArrowRight','Home','End'];
            if (allowedKeys.includes(e.key)) {
              return;
            }
            if (!/^\d$/.test(e.key)) {
              e.preventDefault();
              return;
            }
            const { selectionStart, selectionEnd, value } = e.target;
            const newValStr = value.slice(0, selectionStart) + e.key + value.slice(selectionEnd);
            if (newValStr.length > 3) {
              e.preventDefault();
              return;
            }
            const newValNum = Number(newValStr);
            if (Number.isNaN(newValNum) || newValNum > 100) {
              e.preventDefault();
            }
          }
        },
    }
